module.exports = __webpack_public_path__ + "img/lang_lang.df1a9d3c.jpg";